<template>
  <v-row>
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        :retain-focus="false"
      >
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Dealer List</span>
            </v-card-title>
            <v-card-subtitle>{{
              selectedData ? selectedData.name : ""
            }}</v-card-subtitle>
            <v-card-text>
              <v-data-table
                :headers="table.headers"
                :items="table.data"
                :items-per-page="10"
                :loading="table.loading"
                loading-text="Loading... Please wait"
                class="elevation-1"
              >
                <template
                  v-for="header in table.headers.filter((header) =>
                    header.hasOwnProperty('formatter')
                  )"
                  v-slot:[`item.${header.value}`]="{ value }"
                >
                  {{ header.formatter(value) }}
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "DistributorActivationDetails",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        // transactionDate: "",
        files: null,
      },

      table: {
        sortDesc: true,
        loading: false,

        headers: [
          { text: "Dealer", value: "name" },
          { text: "Count", align: "center", value: "count" },
        ],
        data: [],
        dates: [],
      },
    };
  },

  methods: {
    open(data, dates) {
      this.dialog = true;
      this.table.data = [];

      // console.log(data.dateLabel);
      // console.log(data.retailerId);
      this.selectedData = data;
      this.dates = dates;

      setTimeout(() => {
        this.getList();
      }, 500);

      // this.getPhotos(data.retailerId, data.dateLabel);

      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async getList() {
      this.table.loading = true;
      const payload = {
        startDate: this.dates[0],
        endDate: this.dates[1],
        distributorId: this.selectedData.distributorId,
      };
      await this.$drs
        .post(`/broker/pf-int/dealer-count`, payload)
        .then((response) => {
          const newArr = response.data;
          console.log(newArr);
          this.table.data = newArr.data.sort(function (a, b) {
            return b["count"] - a["count"];
          });
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
